<div class="drop-zone" [class.disabled]="loading" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
  (click)="openFileSelector($event)">
  <button class="modal-close-btn" (click)="closeComponent()">x</button>
  <p class="font-size-15rem font-bold">Drag and drop a file here, or click to select files</p>
  <br>
  <input #fileInput type="file" (change)="handleFiles($event.target.files)" hidden multiple>
  <div *ngIf="files">
    <table class="w-full" *ngIf="files.length">
      <tr>
        <th></th>
        <th>File Name</th>
        <th>Remove</th>
        <th class="text-center">Status</th>
      </tr>
      <tr *ngFor="let file of files; let i = index">
        <td class="w-1rem"></td>
        <td class="vertical-align-middle display-flex">
          <span><img src="../../../assets/document.svg" class="h-2rem w-2rem mr-10px"></span>
          <p class="text-left break-word">{{file.name}}</p>
        </td>
        <td class="w-4rem pt-2px">
          <img *ngIf="file.status == 'Pending'" src="../../../assets/fontawesome-web/svgs/regular/circle-xmark.svg" class="h-2rem w-2rem"
            (click)="removeFile($event, i)">
        </td>
        <td class="w-8rem pb-3px">
          <mat-progress-bar mode="indeterminate" *ngIf="currentIndex && currentIndex == i"></mat-progress-bar>
          <span *ngIf="!(currentIndex && currentIndex == i)">{{file.status}}</span>
          <!-- <span *ngIf="!(currentIndex && currentIndex === i)">{{ fileStatuses && fileStatuses[file] && fileStatuses[file.name] }}</span> -->
        </td>
      </tr>

    </table>

    <div class="overlay" *ngIf="loading">
      <span *ngIf="loading" class="loader"></span>
    </div>
  </div>
</div>
<br>

<div class="flex flex-center w-full">
  <button class="mybutton" [class.disabled]="loading" (click)="uploadFiles()" [disabled]="!files.length || submitFilesDisabled">Submit Files</button>
  <!-- <button class="mybutton" [class.disabled]="loading" (click)="closeComponent()">Close</button> -->
</div>